export const BUILD_VERSION =
  process.env.REACT_APP_BUILD_VERSION || "v0.7.0";
export const BUILD_DATE = "2026-02-06";
